export default {
  SET_DATE_RANGE(state, bindDateRange) {
    state.bindDateRange = bindDateRange
  }
}